import { render, staticRenderFns } from "./IdentityCard.vue?vue&type=template&id=87f8cd0a&scoped=true"
import script from "./IdentityCard.vue?vue&type=script&lang=js"
export * from "./IdentityCard.vue?vue&type=script&lang=js"
import style0 from "./IdentityCard.vue?vue&type=style&index=0&id=87f8cd0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f8cd0a",
  null
  
)

export default component.exports